import { Pipe, PipeTransform } from '@angular/core';
import { PricingEntity } from '../shared';

@Pipe({ name: 'entityLabel' })
export class EntityLabelPipe implements PipeTransform {
    transform(id: string, entities: PricingEntity[]): string {
        return entities.find((entity) => entity.id === id)?.name ?? id;
    }
}
